import * as React from 'react';
import { style } from 'typestyle';
import { px } from 'csx';
import { rebrand } from '../../../theme/color';
import { Tooltip } from './Tooltip';

const styles = {
  badge: style({
    width: px(20),
    height: px(20),
    borderBottomRightRadius: px(4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  tooltip: style({
    backgroundColor: rebrand.secondary[50].toString(),
    borderColor: rebrand.secondary[50].toString(),
    color: rebrand.contrast[50].toString(),
    fontWeight: 'bold',
    fontSize: px(10),
  }),
};

export const NewTrackBadgeTooltip: React.FC = () => (
  <Tooltip className={styles.tooltip} positions={['top']} content={<span>New on Lickd</span>}>
    <div className={styles.badge}>
    </div>
  </Tooltip>
);
